import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Breadcrumb = ({ currentLanguage }) => {
  const breadcrumbItems = [
    {
      label: currentLanguage === 'en' ? 'Home' : 'Nyumbani',
      path: '/homepage'
    },
    {
      label: currentLanguage === 'en' ? 'Practice Areas' : 'Maeneo ya Utendaji',
      path: '/practice-areas-overview',
      current: true
    }
  ];

  return (
    <nav className="flex items-center space-x-2 text-sm mb-8" aria-label="Breadcrumb">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={item.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="text-text-secondary" />
          )}
          {item.current ? (
            <span className="text-primary font-medium">{item.label}</span>
          ) : (
            <Link
              to={item.path}
              className="text-text-secondary hover:text-primary transition-colors duration-200"
            >
              {item.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;